import { useParams } from 'react-router'
import { FormWrapper } from '@/form-control'
import { TextField } from '@/form-control/fields'
import ROUTES from '@/ROUTES'

import { IProvider } from '@/MODELS/provider.model'
import { IProviderCategories } from '@/MODELS/providerCategories.model'

import AdminPageHeader from '@/components/AdminPageHeader'
import Button from '@/components/Button'

export default function AdminProviderCatForm(props: { id?: string }) {
    const params = useParams()
    const id = props?.id ?? params?.id ?? 'new'

    return (
        <>
            <AdminPageHeader heading={id ? 'Edit category' : 'Create New category'} />
            <FormWrapper<IProviderCategories>
                endpoint={ROUTES.admin.providerCategories}
                id={id}
                redirectAfterSubmit='/admin/provider-categories'
                additionalSubmissionRowContent={
                    <div className='flex items-center justify-between w-full gap-x-2 h-fit'>
                        <Button.Back />
                    </div>
                }
            >
                {(f) => (
                    <div className='overflow-hidden bg-white border-gray-200 shadow-sm rounded-xl'>
                        <div className='p-6 space-y-6'>
                            <div className='grid gap-6 lg:grid-cols-2'>
                                <TextField {...f('name')} label='Name' />
                                <div className='lg:col-span-2'>
                                    <TextField {...f('description')} label='Description(optional)' />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </FormWrapper>
        </>
    )
}
